/* MW Fitness — ficha de producto
   1) "Comprar ahora" visible y siempre habilitado. La aceptación de los Términos
      dejó de vivir aquí: ahora ocurre en la pantalla de pago.
   2) Vibración + papelitos al pulsar "Agregar al carrito" y "Comprar ahora".
      Los papelitos son los que ya trae el tema (lienzo #fire_work): en
      "Agregar al carrito" saltan solos, y aquí se replican en "Comprar ahora". */
(function () {
  'use strict';

  /* ---------- estilos propios, para no tocar site.scss.liquid ---------- */
  function ponerEstilos() {
    if (document.getElementById('mwf-prod-css')) return;
    var s = document.createElement('style');
    s.id = 'mwf-prod-css';
    s.textContent =
      '@keyframes mwf-sacude{' +
      '0%,100%{transform:translateX(0)}' +
      '15%{transform:translateX(-5px)}30%{transform:translateX(5px)}' +
      '45%{transform:translateX(-4px)}60%{transform:translateX(4px)}' +
      '75%{transform:translateX(-2px)}90%{transform:translateX(2px)}}' +
      '.mwf-sacude{animation:mwf-sacude .45s ease}' +
      '@media (prefers-reduced-motion:reduce){.mwf-sacude{animation:none}}';
    document.head.appendChild(s);
  }

  /* ---------- 1. Botón "Comprar ahora" ---------- */
  /* El tema pinta ese botón transparente (fondo transparente, texto gris).
     El CSS de la tienda lo deja legible a través de .mwf-pago-wrap--ok,
     así que basta con envolverlo y marcarlo como aceptado. */
  function montarPago() {
    var pago = document.querySelector('.shopify-payment-button');
    if (!pago) return;
    if (pago.offsetParent === null) return; // aún no visible

    var caja = pago.closest ? pago.closest('.mwf-pago-wrap') : null;
    if (!caja) {
      caja = document.createElement('div');
      caja.className = 'mwf-pago-wrap';
      pago.parentNode.insertBefore(caja, pago);
      caja.appendChild(pago);
    }
    caja.classList.add('mwf-pago-wrap--ok');

    /* Restos de la versión anterior: la tapa que bloqueaba el botón, el aviso
       del candado y la casilla que este mismo archivo llegó a crear. */
    var tapa = caja.querySelector('.mwf-pago-tapa');
    if (tapa && tapa.parentNode) tapa.parentNode.removeChild(tapa);

    var padre = caja.parentNode;
    if (padre) {
      ['.mwf-terms__aviso', '.mwf-terms'].forEach(function (sel) {
        var viejo = padre.querySelector(sel);
        if (viejo && viejo.parentNode) viejo.parentNode.removeChild(viejo);
      });
    }
  }

  /* ---------- 2. Vibración + papelitos ---------- */
  var ULTIMA = 0;

  function fiesta(ev) {
    var ahora = new Date().getTime();
    if (ahora - ULTIMA < 700) return; // sin repetir por doble clic
    ULTIMA = ahora;

    // La vibración solo existe en móvil; en escritorio el navegador la ignora.
    try { if (navigator.vibrate) navigator.vibrate([18, 40, 28]); } catch (e) {}

    // Sacudida del propio botón, para que en escritorio también se note.
    var btn = ev && ev.currentTarget;
    if (btn && btn.classList) {
      btn.classList.add('mwf-sacude');
      setTimeout(function () { btn.classList.remove('mwf-sacude'); }, 500);
    }
  }

  function papelitos(ev) {
    var lienzo = document.getElementById('fire_work');
    if (!lienzo || typeof window.addConfetti !== 'function') return;
    lienzo.classList.remove('hide');
    try {
      window.addConfetti(ev);
      if (typeof window.confettiLoop === 'function') window.confettiLoop();
    } catch (e) { return; }

    clearTimeout(window.__mwfPapelT);
    window.__mwfPapelT = setTimeout(function () {
      try { if (window.hideConfetti) window.hideConfetti(); } catch (e) {}
      lienzo.classList.add('hide');
    }, 2600);
  }

  /* "Agregar al carrito" ya trae los papelitos del tema: aquí solo se le suma
     la vibración, o saldrían dos tandas de confeti a la vez. */
  var SOLO_VIBRA = [
    'form[action*="/cart/add"] [type="submit"]',
    '.product-form__cart-submit',
    '.btn-addToCart',
    '.add_to_cart'
  ].join(',');

  var VIBRA_Y_PAPELITOS = '.shopify-payment-button__button';

  function enganchar(sel, conPapelitos) {
    var botones = document.querySelectorAll(sel);
    [].forEach.call(botones, function (b) {
      if (b.getAttribute('data-mwf-fiesta')) return;
      b.addEventListener('click', function (ev) {
        fiesta(ev);
        if (conPapelitos) papelitos(ev);
      });
      b.setAttribute('data-mwf-fiesta', '1');
    });
  }

  function repasar() {
    try { montarPago(); } catch (e) {}
    try { enganchar(SOLO_VIBRA, false); } catch (e) {}
    try { enganchar(VIBRA_Y_PAPELITOS, true); } catch (e) {}
  }

  function iniciar() {
    ponerEstilos();
    repasar();
    // El botón dinámico tarda en aparecer y el tema redibuja al cambiar de variante.
    var obs = new MutationObserver(function () {
      clearTimeout(window.__mwfProdT);
      window.__mwfProdT = setTimeout(repasar, 150);
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(repasar, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();